/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { DeleteAiCredentialMutationResponse, DeleteAiCredentialPathParams, DeleteAiCredential400, DeleteAiCredential401, DeleteAiCredential403, DeleteAiCredential404, DeleteAiCredential409, DeleteAiCredential500 } from "../../types/platformBillingController/DeleteAiCredential.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteAiCredential } from "../../client/platformBillingController/deleteAiCredential.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteAiCredentialMutationKey = () => [{ url: '/api/organizations/:organizationId/platform-billing/credentials/:provider' }] as const

export type DeleteAiCredentialMutationKey = ReturnType<typeof deleteAiCredentialMutationKey>

export function deleteAiCredentialMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteAiCredentialMutationKey()
        return mutationOptions<DeleteAiCredentialMutationResponse, ResponseErrorConfig<DeleteAiCredential400 | DeleteAiCredential401 | DeleteAiCredential403 | DeleteAiCredential404 | DeleteAiCredential409 | DeleteAiCredential500>, {organizationId: DeleteAiCredentialPathParams["organizationId"], provider: DeleteAiCredentialPathParams["provider"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, provider }) => {
            return deleteAiCredential(organizationId, provider, config)
          },
        })

}

/**
 * @summary Delete a BYOK provider key
 * {@link /api/organizations/:organizationId/platform-billing/credentials/:provider}
 */
export function useDeleteAiCredential<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteAiCredentialMutationResponse, ResponseErrorConfig<DeleteAiCredential400 | DeleteAiCredential401 | DeleteAiCredential403 | DeleteAiCredential404 | DeleteAiCredential409 | DeleteAiCredential500>, {organizationId: DeleteAiCredentialPathParams["organizationId"], provider: DeleteAiCredentialPathParams["provider"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteAiCredentialMutationKey()

          const baseOptions = deleteAiCredentialMutationOptions(config) as UseMutationOptions<DeleteAiCredentialMutationResponse, ResponseErrorConfig<DeleteAiCredential400 | DeleteAiCredential401 | DeleteAiCredential403 | DeleteAiCredential404 | DeleteAiCredential409 | DeleteAiCredential500>, {organizationId: DeleteAiCredentialPathParams["organizationId"], provider: DeleteAiCredentialPathParams["provider"]}, TContext>
          

          return useMutation<DeleteAiCredentialMutationResponse, ResponseErrorConfig<DeleteAiCredential400 | DeleteAiCredential401 | DeleteAiCredential403 | DeleteAiCredential404 | DeleteAiCredential409 | DeleteAiCredential500>, {organizationId: DeleteAiCredentialPathParams["organizationId"], provider: DeleteAiCredentialPathParams["provider"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteAiCredentialMutationResponse, ResponseErrorConfig<DeleteAiCredential400 | DeleteAiCredential401 | DeleteAiCredential403 | DeleteAiCredential404 | DeleteAiCredential409 | DeleteAiCredential500>, {organizationId: DeleteAiCredentialPathParams["organizationId"], provider: DeleteAiCredentialPathParams["provider"]}, TContext>
      
}